import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { ChatThread } from "@/components/ChatThread";

export default function AdminChat() {
  const { clientId } = useParams();
  const [client, setClient] = useState(null);
  useEffect(() => { api.get(`/admin/clients/${clientId}`).then((r) => setClient(r.data)).catch(() => {}); }, [clientId]);

  return (
    <div className="max-w-3xl">
      <Link to="/admin/messaggi" className="inline-flex items-center gap-2 text-sm text-[#757575] hover:text-black mb-6" data-testid="back-to-threads"><ArrowLeft className="h-4 w-4" /> Conversazioni</Link>
      <div className="mb-5">
        <p className="rp-label">Chat con</p>
        <Link to={`/admin/clienti/${clientId}`} className="text-3xl font-semibold tracking-tight hover:underline" data-testid="chat-client-name">{client?.name || "…"}</Link>
      </div>
      <ChatThread clientId={clientId} myRole="admin" />
    </div>
  );
}
